import classNames from 'clsx'
import { forwardRef } from 'react'

import S from './Button.module.scss'

export type ButtonSize = 's' | 'm' | 'square' | 'rect'
export type ButtonColor = 'color' | 'secondary' | 'tertiary'

export interface InputProps extends React.ComponentPropsWithoutRef<'button'> {
  size?: ButtonSize
  color?: ButtonColor
  fullWidth?: boolean
}

const Button = forwardRef<HTMLButtonElement, InputProps>(
  (
    {
      className,
      children,
      color = 'color',
      size = 'm',
      fullWidth = false,
      ...props
    },
    ref
  ) => {
    return (
      <button
        {...props}
        className={classNames(
          S.button,
          S[color],
          S[size],
          fullWidth && S.fullWidth,
          className
        )}
        ref={ref}
      >
        {children}
      </button>
    )
  }
)

Button.displayName = 'Button'

export default Button
